import academicYearSlice from "@pages/EducationalSettings/AcademicYear/store/academicYearSlice";
import academicTermsSlice from "@pages/EducationalSettings/AcademicTerm/store/academicTermsSlice";
import studyYearsSlice from "@pages/EducationalSettings/StudyYears/store/studyYearsSlice";
import teachingTypeSlice from "@pages/EducationalSettings/TeachingType/store/teachingTypeSlice";
import qualificationSlice from "@pages/EducationalSettings/Qualification/store/qualificationSlice";
import educationalSectorsSlice from "@pages/EducationalSettings/EducationalSectors/store/educationalSectorsSlice";
import subjectCheckTypeSlice from "@pages/EducationalSettings/SubjectCheckType/store/subjectCheckTypeSlice";
import degreeDurationSlice from "@pages/EducationalSettings/EducationalDuration/store/degreeDurationSlice";

export const settingsReducer = {
    academicYear: academicYearSlice.reducer,
    academicTerms: academicTermsSlice.reducer,
    studyYears: studyYearsSlice.reducer,
    teachingType: teachingTypeSlice.reducer,
    qualification: qualificationSlice.reducer,
    educationalSectors: educationalSectorsSlice.reducer,
    subjectCheck: subjectCheckTypeSlice.reducer,
    degreeDuration: degreeDurationSlice.reducer,
};
